function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React, { useContext, useMemo } from "react";
import cx from "classnames";
import split from "just-split";
import { useUIDSeed } from "react-uid";
import { LinkContext } from "../../../context";
export function Submenu(param) {
    var variant = param.variant, navItems = param.navItems;
    var seed = useUIDSeed();
    var chunkedItems = useMemo(function() {
        var itemsPerGroup = Math.ceil(navItems.length / 3);
        return split(navItems, itemsPerGroup);
    }, [
        navItems
    ]);
    var LinkComponent = useContext(LinkContext).LinkComponent;
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-10 grid-cols-1"
    }, variant === "simple" && /*#__PURE__*/ React.createElement("ul", null, navItems.map(function(item) {
        return /*#__PURE__*/ React.createElement("li", {
            key: seed(item),
            className: "font-medium text-sm"
        }, /*#__PURE__*/ React.createElement(LinkComponent, _extends({}, item, {
            className: "hover:text-brand-primary-base"
        }), item.label));
    })), variant === "complex" && /*#__PURE__*/ React.createElement("div", {
        className: cx("grid", chunkedItems.length <= 1 && "grid-cols-1", chunkedItems.length <= 2 && "grid-cols-2", chunkedItems.length >= 3 && "grid-cols-3")
    }, chunkedItems.map(function(chunk) {
        /*#__PURE__*/ return React.createElement("div", {
            key: seed(chunk),
            className: "grid grid-cols-1 grid-flow-row row"
        }, chunk.map(function(rootItem) {
            var ref;
            /*#__PURE__*/ return React.createElement("ul", {
                key: seed(rootItem)
            }, /*#__PURE__*/ React.createElement("li", {
                className: "font-medium text-sm"
            }, /*#__PURE__*/ React.createElement(LinkComponent, _extends({}, rootItem, {
                className: "hover:text-brand-primary-base"
            }), rootItem.label)), (ref = rootItem.navItems) === null || ref === void 0 ? void 0 : ref.map(function(childItem) {
                return /*#__PURE__*/ React.createElement("li", {
                    key: seed(childItem),
                    className: "not-prose mb-3 last-of-type:mb-0"
                }, /*#__PURE__*/ React.createElement(LinkComponent, _extends({
                    className: "text-sm hover:text-brand-primary-base"
                }, childItem), childItem.label));
            }));
        }));
    })));
}

//# sourceMappingURL=Submenu.js.map